import React from 'react';

/**
 * PageLayout - Use this to wrap every page for consistent width and gutters.
 * - Outer container: max-w-[1525px] mx-auto px-5 (20px gutters)
 * - For main content: use className="max-w-[1495px] mx-auto" on inner divs
 *
 * Example usage:
 * <PageLayout>
 *   <div className="max-w-[1495px] mx-auto">Main content here</div>
 * </PageLayout>
 */
const PageLayout = ({ children, className = '' }) => (
  <div
    className={`min-h-screen flex flex-col mx-auto px-5 w-full transition-colors duration-300`}
    style={{ maxWidth: '1525px' }}
  >
    <div className={className}>
      {children}
    </div>
  </div>
);

export default PageLayout; 